/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SourcingSearchUnavailability = {
    EligibleForSourcing: 'NOT_ELIGIBLE_FOR_SOURCING',
    AvailableDueToPermanentEmployment: 'NOT_AVAILABLE_DUE_TO_PERMANENT_EMPLOYMENT'
} as const;
export type SourcingSearchUnavailability = typeof SourcingSearchUnavailability[keyof typeof SourcingSearchUnavailability];


export function instanceOfSourcingSearchUnavailability(value: any): boolean {
    for (const key in SourcingSearchUnavailability) {
        if (Object.prototype.hasOwnProperty.call(SourcingSearchUnavailability, key)) {
            // @ts-ignore
            if (SourcingSearchUnavailability[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SourcingSearchUnavailabilityFromJSON(json: any): SourcingSearchUnavailability {
    return SourcingSearchUnavailabilityFromJSONTyped(json, false);
}

export function SourcingSearchUnavailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchUnavailability {
    return json as SourcingSearchUnavailability;
}

export function SourcingSearchUnavailabilityToJSON(value?: SourcingSearchUnavailability | null): any {
    return value as any;
}

